// [AI_START::module id="withMaintenance.tsx" purpose="App-shell HOC: block UI when the maintenance feature flag is enabled" links=["useFeatureFlagsMaintenance", "pages/maintenance"]]
import { ComponentProps, ComponentType, FC } from "react";
import { useFeatureFlagsMaintenance } from "~@/feature-flags";
import Maintenance from "~@/pages/maintenance";

// [AI_START::function id="withMaintenance" purpose="Render maintenance page or wrapped app based on maintenance flag" links=["useFeatureFlagsMaintenance"]]
const withMaintenance = <P extends object>(
  WrappedComponent: ComponentType<P>
): FC<P> => {
  return function WithMaintenance(
    props: ComponentProps<typeof WrappedComponent>
  ) {
    const featureFlags = useFeatureFlagsMaintenance();

    if (featureFlags.loading) {
      return null;
    }

    if (featureFlags.enabled) {
      return <Maintenance />;
    }

    return <WrappedComponent {...props} />;
  };
};
// [AI_END::withMaintenance]

export default withMaintenance;
// [AI_END::withMaintenance.tsx]
